<!-- // 重点澄清页面开发 -->
<template>
  <div class="Crisis_Memcon_evaluation">
  
    <!-- 心理普测访谈记录表添加 -->

      <el-form :model="fieldObj" ref="ruleForm" style="padding-top: 20px; padding-bottom: 20px;" label-width="180px" class="demo-ruleForm">
        <el-form-item :label="$t('original.languages108')">
          <el-input :disabled="true" v-model="data.realName" placeholder="请输入..." show-word-limit></el-input>
        </el-form-item>

        <el-form-item label="学号" style="margin-top: 10px;">
          <el-input :disabled="true" v-model="data.userID" placeholder="请输入..." show-word-limit></el-input>
        </el-form-item>

        <el-form-item :label="$t('original.languages109')" style="margin-top:10px">
          <el-date-picker :picker-options="pickerOptions" v-model="value1" type="date" placeholder="选择日期"
            value-format="yyyy-MM-dd" format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>

        <div v-for="(item, index) in fieldArray" :key="index" :class="item.HtmlElements">
          <h2 v-if="item.HtmlElements === '标题'">{{ item.ShowName }}</h2>
          <template v-if="item.HtmlElements === '文本域'">
            <el-form-item :label="item.ShowName" :prop="item.ShowName"
              :rules="item.requiredOrNot == 2 ? [{ required: true, message: '请输入' + item.ShowName, trigger: 'blur' }] : []">
              <el-input type="textarea" maxlength="5000" v-model="item.FormValue" placeholder="请输入..." show-word-limit>
              </el-input>
            </el-form-item>
          </template>

          <template v-if="item.HtmlElements === '填空题'">
            <el-form-item :label="item.ShowName" class="ccc" :prop="item.ShowName" :rules="item.requiredOrNot == 2 ? [{ required: true, message: '请输入' + item.ShowName, trigger: 'blur' }] : []">
              <el-input maxlength="5000" type="textarea" rows="4" :placeholder="item.desc" v-model="item.FormValue"
                show-word-limit></el-input>
            </el-form-item>
          </template>

          <template v-if="item.HtmlElements === '时间选择'">
            <el-form-item :prop="item.ShowName" :label="item.ShowName" :rules="item.requiredOrNot == 2 ? [{ required: true, message: '请选择' + item.ShowName, trigger: 'change' }] : []">
              <el-date-picker v-model="item.FormValue" :name="item.ShowName" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd" :placeholder="item.desc"></el-date-picker>
            </el-form-item>
          </template>

          <template v-if="item.HtmlElements === '下拉选择'">
            <el-form-item :label="item.ShowName" :prop="item.ShowName"
              :rules="item.requiredOrNot == 2 ? [{ required: true, message: '请选择' + item.ShowName, trigger: 'change' }] : []">
              <el-select v-model="item.FormValue" :placeholder="item.describe">
                <el-option v-for="items in item.list" :key="items.name" :label="items.name" :value="items.value">
                </el-option>
              </el-select>
            </el-form-item>
          </template>

          <template v-if="item.HtmlElements === '单选题'">
            <el-form-item :label="item.ShowName" :prop="item.ShowName" :rules="item.requiredOrNot == 2 ? [{ required: true, message: '请选择' + item.ShowName, trigger: 'change' }] : []">
              <template v-for="child in item.Bobbies" style="margin-top: -20px;">
                <el-radio v-bind:style="{ color: child.FontColor }" v-model="item.FormValue" :label="child.Value">{{ child.Name }}</el-radio>
              </template>
              <el-form-item style="display: inline-block;margin-left: 20px;" v-for="itmes in item.Bobbies" :key="itmes.index">
                <el-input style="width: 300px;height: 80px;" type="textarea" maxlength="5000" v-if="itmes.Display" v-model="itmes.FormValue" placeholder="请输入..." show-word-limit></el-input>
              </el-form-item>
            </el-form-item>
          </template>

          <template v-if="item.HtmlElements === '多选题'" class="复选框">
            <el-form-item :label="item.ShowName" :prop="item.ShowName" :rules="item.requiredOrNot == 2 ? [{ required: true, message: '请选择' + item.ShowName, trigger: 'change' }] : []">
              <el-checkbox-group v-model="item.FormValue" style="display: inline-block;">
                <template v-for="child in item.hobbies">
                  <el-checkbox :label="child.name"></el-checkbox>
                </template>
              </el-checkbox-group>
              <el-form-item label="其他" v-if="item.duo" style="display: inline-block;margin-left: 20px;">
                <el-input v-model="item.FormValue" placeholder="请输入内容"></el-input>
              </el-form-item>
            </el-form-item>
          </template>
          
        </div>
      </el-form>

      <span slot="footer" class="dialog-footer" style="">
        <div style="padding-bottom: 20px;margin-left: 40%;" >
          <el-button @click="wppgai()"> {{ $t('original.languages164') }}</el-button>
          <el-button type="primary" @click="submitForm()"> {{ $t('original.save') }}</el-button>
        </div>
      </span>

  </div>
</template>
<script>
export default {
  mounted() { },
  data() {
    return {
      TalkNo: '',
      entity: '',
      xaukm: true,
      zhungtai: '',
      visible: true,
      c3: true,//判断是否访谈
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      entity: sessionStorage.getItem('entity'),
      zhedie: true,
      chongzhiDeptID: '',
      Determine_random: true, //判断是否点击随机访谈
      gysjhxss: [], //分页后端要的总数据
      gysjhx: [], //分页后端要的十条数据
      listCountS: [],
      Random: 0,
      SaveFlg: 1,
      data: [],
      bans: true,
      DeptID: '',
      optionsnew: [],
      GetSubjectPublishList: [],
      wdisabled: true,
      VsitorNameList: [],
      value1: '',
      wUserID: '',
      fieldObj: {},
      fieldArray: [], //表单字段集合
      loading: true,
      wpppd: true,
      testcount: { one: 0, tow: 0, three: 0, four: 0, five: 0, six: 0 },
      interviewcount: { one: 0, tow: 0, three: 0, four: 0, five: 0, six: 0 },
      tableList: [],
      PaperList: [],
      Paperhead: {
        Name: '',
        Sex: '',
        DeptName: '',
        UserID: '',
        Result: '',
        PublishID: '',
        Remark: '',
      },
      interviewfrom: {
        val1: '',
        val2: '',
        val3: [],
        val4: '',
        val5: [],
        val6: '',
        val7: [],
        val8: [],
        val9: '',
        val10: '',
        val11: '',
        val12: [],
        val13: '',
        val14: '',
        val15: '',
        val16: [],
        val17: '',
        val18: '',
        val19: '',
        val20: '',
        val21: '',
      },
      centerDialogVisible: false, //查看测评量表
      interviewVisible: false, //访谈跟进
      interviewVisible2: false, //访谈跟进查看修改
      ruleForm: {
        UserID: '',
        General: '',
        PublishSubject: '',
        state: '',
        interview: '',
        progress: '',
        Source: '-1',
      },
      options: [
        { value: '良好', label: '良好' },
        { value: '轻度', label: '轻度' },
        { value: '中度', label: '中度' },
        { value: '重度', label: '重度' },
      ],
      options2: [
        { value: '无需访谈', label: '无需访谈' },
        { value: '需要访谈', label: '需要访谈' },
        { value: '已预约', label: '已预约' },
        { value: '已跟进', label: '已跟进' },
        { value: '未上报', label: '未上报' },
        { value: '已上报', label: '已上报' },
      ],
      options3: [
        { value: '良好', label: '良好' },
        { value: '轻度', label: '轻度' },
        { value: '中度', label: '中度' },
        { value: '重度', label: '重度' },
        { value: '无法确定', label: '无法确定' },
        { value: '严重且紧急', label: '严重且紧急' },
      ],
      options4: [
        { value: '1', label: '已完成' },
        { value: '0', label: '未完成' },
      ],
      PageInfo: { CurrentIndex: 0, PageSize: 10, PageIndex: 1, TotleCount: 0, TotlePageCount: 0 },
      AllCount: -1,
    };
  },
  mounted: function () {
    this.TalkNo = [this.$route.query.TalkNo][0];
    if([this.$route.query.type][0] == 1){
      this.$Http_Post('/management/distressPrediction/prefabricatedTableData', { keyNo: this.TalkNo }).then((res) => {
        if (res.Code == 200 || res.Code == 0 && res.Data) {
          this.data = res.Data;
        }
      });
    }else{
      this.$Http_Post('/DistressPrediction/ToExamineData', { TalkNo: this.TalkNo }).then((res) => {
        if (res.Code == 200 || res.Code == 0 && res.Data) {
          this.data = res.Data;
        }
      });
    }
    this.entity = sessionStorage.getItem('entity');
    this.GettableList();
    this.GetSubjectPublish();
    this.openInterviewVisible();
  },
  methods: {

    wjsb() {
      this.$Http_Post('Crisis_Memcon_evaluation/VerifyReported', { pageSize: this.PageInfo.PageSize, pageIndex: this.PageInfo.PageIndex, UserID: this.ruleForm.UserID, General: this.ruleForm.General, PublishSubject: this.ruleForm.PublishSubject, state: this.ruleForm.state, interview: this.ruleForm.interview, progress: this.ruleForm.progress, DeptID: this.DeptID, Source: this.ruleForm.Source, Random: this.Random }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.Global.request_successful(res.Message);
          this.GettableList();
        } else {
          this.Global.request_failure(res.Message);
        }
      });
    },

    handleClose(done) {
      this.$confirm(this.$t('original.languages60')).then(_ => {
        done();
        this.Paperhead.Remark = '';
      })
      .catch(_ => {

      });
    },

    whandleClose(done) {
      this.$confirm(this.$t('original.languages60'))
      .then(_ => {
        done();
        this.Paperhead.Remark = ''
      })
      .catch(_ => {

      });
    },

    zhedies() {
      this.zhedie = false;
    },
    zhankai() {
      this.zhedie = true;
    },
    Randomfun() {
      this.loading = true;
      this.Determine_random = false;
      this.Random = 1;
      this.ruleForm.UserID = '';
      this.ruleForm.General = '';
      this.ruleForm.state = '';
      this.ruleForm.interview = '';
      this.ruleForm.progress = '';
      this.ruleForm.Source = '-1';
      this.RandomInterviews();
    },

    RandomInterviews() {
      this.$Http_Post('/Crisis_Memcon_evaluation/RandomInterviews', {
        PublishID: this.ruleForm.PublishSubject,
        UserIDList: this.gysjhx,
        UserIDListTwo: this.GetTableList,
        DeptID: this.DeptID,
      }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.tableList = res.Data.list1;
          this.GetTableList = res.Data.listCountS;
          this.loading = false;
          if (res.Data.Counts >= 10) {
            this.wpppd = false;
          } else {
            this.wpppd = true;
          }
          this.AllCount = res.Counts;
        } else {
          this.loading = false;
          this.Global.request_failure(res.Message);
        }
      });
    },

    AddCombineResult(row) {
      this.$Http_Post('/Crisis_Memcon_evaluation/AddCombineResult', {UserID: row.UserID,PublishID: row.PublishID}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.Global.request_successful(res.Message);
          this.GettableList();
        } else {
          this.Global.request_failure(res.Message);
        }
      });
    },

    DeleteCombineResult(row) {
      this.$Http_Post('/Crisis_Memcon_evaluation/DeleteCombineResult', {UserID:row.UserID,PublishID:row.PublishID}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.Global.request_successful(res.Message);
          this.GettableList();
        } else {
          this.Global.request_failure(res.Message);
        }
      });
    },

    AddCombineResultStochastic() {
      this.visible = false;
      this.$Http_Post('/Crisis_Memcon_evaluation/AddCombineResultStochastic', {UserIDList:this.GetTableList,PublishID:this.ruleForm.PublishSubject}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.Global.request_successful(res.Message);
          this.GettableList();
          this.Determine_random = true;
        } else {
          this.Global.request_failure(res.Message);
        }
      });
    },

    getVsitorNameList(query) {
      if (query !== '') {
        this.loadingstart = true;
        this.$Http_Post('ConsultSubscribe/GetBlacklistNameList', { Query: query }).then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            this.loadingstart = false;
            this.VsitorNameList = res.Data;
          }
        });
      } else {
        this.VsitorNameList = [];
      }
    },

    selectVsitorName() {
      for (let index = 0; index < this.VsitorNameList.length; index ++) {
        if (this.VsitorNameList[index].UserID == this.wUserID) {
          this.addInformationShow = true;
          this.DeptName = this.VsitorNameList[index].DeptName;
        }
      }
    },

    getFieldData() {
      let response = this.fieldArray;
      for (let i = 0; i < response.length; i++) {
        let item = response[i];
        if (item.HtmlElements === '复选框') {
          this.$set(this.fieldObj, item.ShowName, []);
        } else {
          this.$set(this.fieldObj, item.ShowName, item.showValue);
        }
      }
    },

    submitForm(formName) {//提交验证
      this.interviewVisible = false;
      var xks;

      if([this.$route.query.type][0] == 1){
        xks = '危机上报'
      }else{
        xks = '重点访谈'
      }

      this.$Http_Post('CrisisWarning/AddingConfigForm', {
        userid: this.data.userID,//学号
        createtime: this.value1,//访谈时间
        form: this.fieldArray,
        TableName: xks,
        PublishID: [this.$route.query.SourceNo][0],
        Modify: false,
        Remark: this.data.realName,//姓名
        AdjustBefore: this.data.talkCrisisGrade,
        keyno: [this.$route.query.TalkNo][0],
        type: [this.$route.query.type][0],
        KeyNos:[this.$route.query.KeyNo][0],
        hy:[this.$route.query.hy][0],
      }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.Paperhead.Remark = ''
          this.Global.request_successful(res.Message);
          this.$router.push({
            path: '/Crisis/Crisis_upreport'
          })
        }
      });
    },

    submitForm2(formName) {//提交修改
      if([this.$route.query.type][0] == 1){
        xks = '危机上报'
      }else{
        xks = '新生心理普测访谈记录表'
      }

      (this.interviewVisible = false),
      this.$Http_Post('CrisisWarning/AddingConfigForm', {
        userid: this.Paperhead.UserID,
        createtime: this.value1, 
        form: this.fieldArray, 
        TableName: xks,
        PublishID: this.Paperhead.PublishID, 
        Modify: true, 
        Remark: this.Paperhead.Remark,
        keyno: [this.$route.query.TalkNo][0],
        type: [this.$route.query.type][0],
      }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.interviewVisible2 = false;
          this.Global.request_successful(res.Message);
          this.GettableList();
          this.Paperhead.Remark = '';
        }
      });
    },

    wppgai(){
      if([this.$route.query.type][0] == 1){
        this.$router.push({
          path: '/Crisis/Crisis_upreport'
        })
      }else{
        this.$router.push({
          path: '/Crisis/Crisis_Intervent'
        })
      }
    },
    resetForm() {
      this.Determine_random = true;
      this.ruleForm.UserID = '';
      this.ruleForm.General = '';
      this.ruleForm.PublishSubject = '';
      this.ruleForm.state = '';
      this.ruleForm.interview = '';
      this.ruleForm.progress = '';
      this.DeptID = this.chongzhiDeptID;
      this.ruleForm.Source = '-1';
      this.c3 = false;
      this.GettableList();
    },

    openReport(a) {
      let routeData = this.$router.resolve({
        path:'/visitors/ReportShow',
        query:{PaperResultID:a},
      });
      window.open(routeData.href, '_blank');
    },

    openInterviewFormVisible(row) {//查看修改
      this.zhungtai = row.State;
      this.fieldArray = [];
      this.Paperhead.Name = row.RealName;
      this.Paperhead.Sex = row.Sex;
      this.Paperhead.Result = row.Result;
      this.Paperhead.UserID = row.UserID;
      this.Paperhead.PublishID = row.PublishID;
      this.$Http_Post('CrisisWarning/GetFormView', {
        TableName: '新生心理普测访谈记录表', 
        PublishID: this.Paperhead.PublishID,
        UserID: this.Paperhead.UserID}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.fieldArray = res.Data.sys_Forms;
          this.value1 = res.Data.createtime;
          this.Paperhead.Remark = res.Data.Remark;
          this.interviewVisible2 = true;
        }
      });
    },

    openInterviewVisible(row) {//新增
      this.$Http_Post('CrisisWarning/GetPageList', { TableName: '新生心理普测访谈记录表' }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.fieldArray = res.Data.FormConfigurations;
          this.SaveFlg = res.Data.SaveFlg;
          this.interviewVisible = true;
        }
      });
    },

    OpenCenterDialogVisible(row) {
      if (row.Percentage != 0) {
        this.centerDialogVisible = true;
        this.Paperhead.Name = row.RealName;
        this.Paperhead.Sex = row.Sex;
        this.Paperhead.DeptName = row.DeptName;
        this.Paperhead.UserID = row.UserID;
        this.$Http_Post('Crisis_Memcon_evaluation/GetPaperList', { UserID: row.UserID, PublishID: row.PublishID, }).then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            this.PaperList = res.Data;
          }
        });
      }
    },

    GetSubjectPublish() {
      this.$Http_Post('/management/emphasisclarification/getsubjectpublish').then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.GetSubjectPublishList = res.Data;
        }
      });
    },

    ExportTableList() {
      this.daochu = true;
      this.$Http_Post('Crisis_Memcon_evaluation/ExportTableList', { UserID: this.ruleForm.UserID, General: this.ruleForm.General, PublishSubject: this.ruleForm.PublishSubject, state: this.ruleForm.state, interview: this.ruleForm.interview, progress: this.ruleForm.progress, DeptID: this.DeptID, Source: this.ruleForm.Source }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.daochu = false;
          this.Global.request_successful(res.Message);
          window.location.href = res.Data;
        } else {
          this.daochu = false;
          this.Global.request_failure(res.Message);
        }
      });
    },

    GettableList(a) {
      this.xaukm = true;
      this.testcount = { one: 0, tow: 0, three: 0, four: 0, five: 0, six: 0 };
      this.interviewcount = { one: 0, tow: 0, three: 0, four: 0, five: 0, six: 0 };
      this.loading = true;
      if (a == 1) {
        this.PageInfo.PageIndex = 1;
      }
      this.$Http_Post('/management/emphasisclarification/getpaperlist', { pageSize: this.PageInfo.PageSize, pageIndex: this.PageInfo.PageIndex, UserID: this.ruleForm.UserID, General: this.ruleForm.General, PublishSubject: this.ruleForm.PublishSubject, state: this.ruleForm.state, interview: this.ruleForm.interview, progress: this.ruleForm.progress, DeptID: this.DeptID, Source: this.ruleForm.Source, Random: this.Random }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.xaukm = false;
          if (res.Data.list1.length > 0) {
            this.c3 = res.Data.list1[0].c3
          }
          this.GetTableList = res.Data.listCountS;
          this.loading = false;
          if (res.Data.Counts >= 10) {
            this.wpppd = false;
          } else {
            this.wpppd = true;
          }
          this.tableList = res.Data.list1;
          this.AllCount = res.Counts;
          let count = res.Data.count;
          this.ruleForm.PublishSubject = res.Data.PublishID;
          let count1 = res.Data.count1;
          this.testcount.one = 0;
          for (let index = 0; index < count.length; index++) {
            if (count[index].key == '重度') {
              this.testcount.one = this.testcount.one + parseInt(count[index].count);
              this.testcount.tow = parseInt(count[index].count);
            }
            if (count[index].key == '中度') {
              this.testcount.one = this.testcount.one + parseInt(count[index].count);
              this.testcount.three = parseInt(count[index].count);
            }
            if (count[index].key == '轻度') {
              this.testcount.four = parseInt(count[index].count);
            }
            if (count[index].key == '良好') {
              this.testcount.five = parseInt(count[index].count);
            }
            if (count[index].key == '重度且紧急') {
              this.testcount.one = this.testcount.one + parseInt(count[index].count);
              this.testcount.six = parseInt(count[index].count);
            }
          }
          
          this.interviewcount.one = 0;
          for (let index = 0; index < count1.length; index++) {
            if (count1[index].key == '重度') {
              this.interviewcount.one = this.interviewcount.one + parseInt(count1[index].count);
              this.interviewcount.tow = parseInt(count1[index].count);
            }
            if (count1[index].key == '中度') {
              this.interviewcount.one = this.interviewcount.one + parseInt(count1[index].count);
              this.interviewcount.three = parseInt(count1[index].count);
            }
            if (count1[index].key == '轻度') {
              this.interviewcount.four = parseInt(count1[index].count);
            }
            if (count1[index].key == '良好') {
              this.interviewcount.five = parseInt(count1[index].count);
            }
            if (count1[index].key == '严重且紧急') {
              this.interviewcount.one = this.interviewcount.one + parseInt(count1[index].count);
              this.interviewcount.six = parseInt(count1[index].count);
            }
          }

        } else {
          this.loading = false;
        }
      });
    },
    handleCurrentChange: function (val) {
      this.SelectObj = val;
    },
    current_change: function (currentPage) {
      if (this.Determine_random) {
        this.PageInfo.PageIndex = currentPage;
        this.GettableList();
      } else {
        this.gysjhx = this.GetTableList.slice(
          currentPage * 10 - 10,
          currentPage * 10
        );
        this.RandomInterviews();
      }
    },
  },
};
</script>
<style>
.Crisis_Memcon_evaluation{
  height: auto !important;
  background-color: rgba(255, 255, 255, 1);
}

.Crisis_Memcon_evaluation .el-main {
  margin-top: 20px;
  background-color: rgba(255, 255, 255, 1);
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

input[type='number'] {
  -moz-appearance: textfield;
}

.Crisis_Memcon_evaluation .boxs {
  background: rgba(245, 247, 250, 1);
  margin-top: 15px;
}

.Crisis_Memcon_evaluation .boxs button {
  float: right;
  margin-right: 20px;
}

.Crisis_Memcon_evaluation .mild {
  padding: 0px 15px;
  background: rgba(29, 154, 255, 0.1);
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 0px;
  color: rgba(29, 154, 255, 1);
}

.Crisis_Memcon_evaluation .moderate {
  padding: 0px 15px;
  background: rgba(255, 193, 23, 0.1);
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 0px;
  color: rgba(255, 193, 23, 1);
}

.Crisis_Memcon_evaluation .severe {
  padding: 0px 15px;
  background: rgba(255, 141, 26, 0.1);
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 0px;
  color: rgba(255, 141, 26, 1);
}

.Crisis_Memcon_evaluation .well {
  padding: 0px 15px;
  background: rgba(21, 191, 109, 0.1);
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 0px;
  color: rgba(21, 191, 109, 1);
}

.Crisis_Memcon_evaluation .urgency {
  padding: 0px 15px;
  background: rgba(191, 41, 21, 0.1);
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 0px;
  color: rgb(248, 4, 4);
}

.Crisis_Memcon_evaluation .colrowstyle {
  height: 40px;
  line-height: 40px;
  color: rgba(92, 92, 92, 1);
  background: rgba(245, 247, 250, 1);
}

.Crisis_Memcon_evaluation .colrowspanstyle {
  line-height: 40px;
  border-top: 1px solid rgba(225, 226, 227, 1);
  border-left: 1px solid rgba(225, 226, 227, 1);
  border-right: 1px solid rgba(225, 226, 227, 1);
}

.Crisis_Memcon_evaluation .colrowspanbottomstyle {
  border-bottom: 1px solid rgba(225, 226, 227, 1);
}

.Crisis_Memcon_evaluation .noneborder input {
  border: 0px;
}

.Crisis_Memcon_evaluation .bottomborder input {
  border-bottom: 1px solid rgba(166, 166, 166, 1);
}

.Crisis_Memcon_evaluation h2 {
  padding-top: 14px;
  margin-bottom: 14px;
  margin-left: 20px;
}

.Crisis_Memcon_evaluation .标题 {
  width: 100%;
}

.Crisis_Memcon_evaluation .el-form>div {

}

.Crisis_Memcon_evaluation .输入框 input {
  width: initial;
  width: 400px;
}

.Crisis_Memcon_evaluation .el-input__inner {
  width: initial;
}
.Crisis_Memcon_evaluation .el-input{width: 19%;}
.Crisis_Memcon_evaluation .el-form-item__label {
  width: initial !important;
  display: inline-block;
  text-align: right;
  min-width: 90px;
  text-align: left;
  width: 132px !important;
}

.Crisis_Memcon_evaluation .el-textarea {
  width: 170%;
}

.Crisis_Memcon_evaluation  .el-form-item__content {
  margin-left: initial !important;
  display: inline-block;
}

.Crisis_Memcon_evaluation .el-textarea__inner {
  height: 100%;
}

.Crisis_Memcon_evaluation .ccc .el-form-item__content {
  width: 50%;
}

.复选框 .el-form-item__label {
  min-width: 40px !important;
}

.Crisis_Memcon_evaluation .el-form-item {
  margin-bottom: 0px;
}

.填空题,.单选题,.时间选择,.文本域 {
  padding: 6px;
  border: 1px solid rgb(235, 235, 235);
  margin-top: 4px;
}

.Crisis_Memcon_evaluation .el-form-item {
  margin-left: 20px;
}

.el-table--enable-row-transition .el-table__body td {
  text-align: center;
}</style>
